import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import API from '../../../src/config/axios.config';
import { API_ENDPOINTS } from '../../../src/shared/api-endpoints';

interface EditSliceState {
	editresponse: any;
	status: boolean;
	error: string | null;
}

const initialState: EditSliceState = {
	editresponse: {},
	status: false,
	error: null
};

const chatEdit = createAsyncThunk<any, any>('editslice/chatEdit', async (payload, thunkAPI) => {
	try {
		const response = await API.patch(API_ENDPOINTS.CHAT_EDIT, payload);
		return response.data;
	} catch (error: any) {
		return error.response.data;
	}
});

const editSlice = createSlice({
	name: 'editslice',
	initialState,
	reducers: {
		reset: () => initialState
	},
	extraReducers: (builder) => {
		builder
			.addCase(chatEdit.pending, (state) => {
				state.status = true;
				state.error = null;
			})
			.addCase(chatEdit.fulfilled, (state, action: PayloadAction<any>) => {
				state.status = false;
				state.editresponse = action.payload;
			})
			.addCase(chatEdit.rejected, (state, action) => {
				state.status = false;
				state.error = action.error.message || 'Failed to patch chat data';
			});
	}
});

export { chatEdit };
export const { reset: resetEditSlice } = editSlice.actions;
export const editSliceReducer = editSlice.reducer;
